import BaseService from './base';

class UserService extends BaseService {
  constructor() {
    super();
    const base = this.constructor.init();
    this.$http = base.$http;
  }

  setToken = token => {
    this.$http.defaults.headers['Authorization'] = `${token}`;
  };

  async auth(email, password) {
    const userData = {
      email,
      password,
    };
    const result = await this.post('/user/authenticate', userData);
    return result;
  }

  async register(email, username, password, confirmPassword) {
    const userData = {
      email,
      username,
      password,
      confirmPassword,
    };
    const result = await this.post('/user/register', userData);
    return result;
  }

  async logout() {
    const result = await this.post('/user/logout');
    return result;
  }

  async forgotPassword(email) {
    const result = await this.post('/user/password/reset/link/generate', {
      email,
    });
    return result;
  }

  async resetPassword(email, password, confirmPassword, resetPasswordToken) {
    const result = await this.post('/user/password/reset', {
      email,
      password,
      confirmPassword,
      resetPasswordToken,
    });
    return result;
  }

  async getUser() {
    const result = await this.get('/user/me');
    return result;
  }

  async validateFieldUniqueness(field, value) {
    const result = await this.post(`/user/unique/${field}`, value);
    return result;
  }

  async validateResetKey(key) {
    const result = await this.post('/user/password/reset/link/validate', key);
    return result;
  }

  async updateField(field, value) {
    const result = await this.post(`/user/update/${field}`, value);
    return result;
  }

  async getGameState(gameId) {
    const result = await this.get(
      `/user/game/state${gameId !== undefined ? `/${gameId}` : ''}`
    );
    return result;
  }
}

export default new UserService();
